import { defineStore } from "pinia";
import { ref } from "vue";
import { cnmcApi } from "./cnmcApi";
import type { CnmcPlan, CnmcTemplate } from "./cnmcTypes";

export const useCnmcIssuanceStore = defineStore("cnmcIssuance", () => {
  const plans = ref<CnmcPlan[]>([]);
  const templates = ref<CnmcTemplate[]>([]);
  const loading = ref(false);
  const hasMore = ref(false);
  let revision = 0;

  /** Refetch the selected connection; discard responses for a previous selection. */
  const load = async (companyId: number, connectionId: number, offset = 0) => {
    const current = ++revision;
    loading.value = true;
    try {
      const [batchResponse, templateResponse] = await Promise.all([
        cnmcApi.plans(companyId, connectionId, offset),
        cnmcApi.templates(companyId, connectionId),
      ]);
      if (revision !== current) return;
      plans.value = batchResponse.data.plans;
      hasMore.value = batchResponse.data.has_more;
      templates.value = templateResponse.data.templates;
    } finally {
      if (revision === current) loading.value = false;
    }
  };
  const reset = () => {
    revision++;
    plans.value = [];
    templates.value = [];
    hasMore.value = false;
    loading.value = false;
  };
  return { plans, templates, loading, hasMore, load, reset };
});
